import script from "./CustomerRevise.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRevise.vue?vue&type=script&setup=true&lang=js"

import "./CustomerRevise.vue?vue&type=style&index=0&id=5610d414&lang=css"

const __exports__ = script;

export default __exports__